import Crud from '../components/Sector/Crud'

let routes = {
    path: '/sectors',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
      {
          path: '/sectors/:operation?/:id?',
          name: 'Departamentos',
          component: Crud
      },
    ]
}

export default routes


// WEBPACK FOOTER //
// ./src/router/sector.js